// extracted by mini-css-extract-plugin
export default {"num":"Delegatitem_num__-G-9M"};